export default __webpack_public_path__ + "static/media/pexels-emre-can-2079438.53494a65.jpg";